export const LocalStorageKeys = {
    CLIENT_CONFIG_PRIMARY_COLOR: 'CLIENT_CONFIG_PRIMARY_COLOR',
    CLIENT_CONFIG_SECONDARY_COLOR: 'CLIENT_CONFIG_SECONDARY_COLOR',
    MARKETING_INFO: 'appMiParams',
};
